import React from 'react';
import { Route } from 'react-router';

import { getDealerRoutes } from 'app/dealer/routes';

import { ConnectedAppWithErrorBoundary } from './App';
import { ErrorPage } from './shared/components/ErrorPage/ErrorPage';

export const getRoutes = (store) => (
  <Route path="/" component={ConnectedAppWithErrorBoundary}>
    {getDealerRoutes(store)}
    <Route path="*" component={ErrorPage} />
  </Route>
);
